/* Tiger Wear — Sticky mobile add-to-cart bar */
(function () {
  function init() {
    var bar = document.querySelector('[data-tw-sticky]');
    if (!bar || bar.dataset.twInit) return;
    bar.dataset.twInit = '1';

    var sectionId = bar.getAttribute('data-section-id');
    var variants = {};
    try {
      variants = JSON.parse(bar.querySelector('[data-tw-sticky-variants]').textContent);
    } catch (e) {}

    var priceEl = bar.querySelector('[data-tw-sticky-price]');
    var btn = bar.querySelector('[data-tw-sticky-btn]');
    var mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    var form =
      document.querySelector('product-form form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]');

    function currentVariantId() {
      var input = form && form.querySelector('.product-variant-id');
      return input ? input.value : null;
    }

    function state() {
      var id = currentVariantId();
      var info = id && variants[id];
      var available = info ? info.available === true : (mainBtn ? !mainBtn.hasAttribute('disabled') : true);
      if (info && priceEl) priceEl.textContent = info.price;
      btn.textContent = available ? 'Add to cart' : 'Notify me';
      btn.dataset.mode = available ? 'add' : 'notify';
    }

    btn.addEventListener('click', function () {
      if (btn.dataset.mode === 'add' && mainBtn) {
        mainBtn.click();
      } else {
        var notify = document.getElementById('TwNotify-' + sectionId);
        if (notify) {
          notify.removeAttribute('hidden');
          notify.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var input = notify.querySelector('input[type="email"]');
          if (input) setTimeout(function () { input.focus(); }, 400);
        } else if (mainBtn) {
          mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });

    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects, .product-form__input')) {
        setTimeout(state, 60);
      }
    });

    // Show the bar only on mobile, only once the real button is out of view.
    var mq = window.matchMedia('(max-width: 749px)');
    function setVisible(v) { bar.classList.toggle('is-visible', v && mq.matches); }

    if ('IntersectionObserver' in window && mainBtn) {
      var io = new IntersectionObserver(function (entries) {
        setVisible(!entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
      io.observe(mainBtn);
    } else {
      window.addEventListener('scroll', function () {
        if (!mainBtn) return;
        var r = mainBtn.getBoundingClientRect();
        setVisible(r.bottom < 0 || r.top > window.innerHeight);
      }, { passive: true });
    }
    mq.addEventListener && mq.addEventListener('change', function () { setVisible(bar.classList.contains('is-visible')); });

    state();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
